import React from "react";
import PropTypes from "prop-types";

import { useUserIntegrationApps } from "./hooks";
import { IntegrationApp } from "./components";

function IntegrationApps({ showConnectedApps }) {
  const { connectedApps, availableApps } = useUserIntegrationApps();

  const appsToShow = showConnectedApps ? connectedApps : availableApps;

  if (!appsToShow?.length) {
    return (
      <span style={{ color: "grey", fontSize: "16px" }}>
        {showConnectedApps
          ? "No connected apps."
          : "You are connected to all available apps."}
      </span>
    );
  }

  return appsToShow.map((props) => {
    return <IntegrationApp key={props.name} {...props} />;
  });
}

IntegrationApps.propTypes = { showConnectedApps: PropTypes.bool };

IntegrationApps.defaultProps = { showConnectedApps: false };

export default IntegrationApps;
